export const pivotHeaderGhostElementClassname = "ghostPivotElement";
export const pivotHeaderClassName = "pivot-header-root";
